import React from 'react'
import prot01 from '../../assets/images/home_page_4/portfolio/01.png'
import prot02 from '../../assets/images/home_page_4/portfolio/02.png'
import prot03 from '../../assets/images/home_page_4/portfolio/03.png'
import prot04 from '../../assets/images/home_page_4/portfolio/04.png'
import prot05 from '../../assets/images/home_page_4/portfolio/05.png'


const Portfolio = () => {
    return (
        <>
            <section id="portfolio" className="portfolio-main-block">
                <div className="container">
                    <div className="row">
                        <div className="portfolio-nav-tabs">
                            <ul
                                className="nav nav-pills mb-3 justify-content-center"
                                id="pills-tab"
                                role="tablist"
                            >
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link active"
                                        id="pills-project-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-project"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-project"
                                        aria-selected="true"
                                    >
                                        All Projects
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="pills-architect-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-architect"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-architect"
                                        aria-selected="false"
                                    >
                                        Architecher
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="pills-large-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-large"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-large"
                                        aria-selected="false"
                                    >
                                        Large
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="pills-interiour-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-interiour"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-interiour"
                                        aria-selected="false"
                                    >
                                        Interiour
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className="nav-link"
                                        id="pills-house-tab"
                                        data-bs-toggle="pill"
                                        data-bs-target="#pills-house"
                                        type="button"
                                        role="tab"
                                        aria-controls="pills-house"
                                        aria-selected="false"
                                    >
                                        House
                                    </button>
                                </li>
                            </ul>
                        </div>
                        <div className="tab-content" id="pills-tabContent">
                            <div
                                className="tab-pane fade show active"
                                id="pills-project"
                                role="tabpanel"
                                aria-labelledby="pills-project-tab"
                                
                            >
                                <div className="row">
                                    <div className="col-lg-8 col-md-8">
                                        <div className="portfolio-block">
                                            <div className="portfolio-img">
                                                <img
                                                    src={prot01}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                                <div className="overlay-bg" />
                                            </div>
                                            <div className="portfolio-dtl">
                                                <h5 className="portfolio-title">Mind Tech</h5>
                                                <p>Las Vegas</p>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-lg-6 col-md-6">
                                                <div className="portfolio-block">
                                                    <div className="portfolio-img">
                                                        <img
                                                            src={prot03}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                        <div className="overlay-bg" />
                                                    </div>
                                                    <div className="portfolio-dtl">
                                                        <h5 className="portfolio-title">Mind Tech</h5>
                                                        <p>Las Vegas</p>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="col-lg-6 col-md-6">
                                                <div className="portfolio-block">
                                                    <div className="portfolio-img">
                                                        <img
                                                            src={prot04}
                                                            className="img-fluid"
                                                            alt=""
                                                        />
                                                        <div className="overlay-bg" />
                                                    </div>
                                                    <div className="portfolio-dtl">
                                                        <h5 className="portfolio-title">Mind Tech</h5>
                                                        <p>Las Vegas</p>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-4">
                                        <div className="portfolio-block">
                                            <div className="portfolio-img">
                                                <img
                                                    src={prot02}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                                <div className="overlay-bg" />
                                            </div>
                                            <div className="portfolio-dtl">
                                                <h5 className="portfolio-title">Mind Tech</h5>
                                                <p>Las Vegas</p>
                                            </div>
                                        </div>
                                        <div className="portfolio-block">
                                            <div className="portfolio-img">
                                                <img
                                                    src={prot05}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                                <div className="overlay-bg" />
                                            </div>
                                            <div className="portfolio-dtl">
                                                <h5 className="portfolio-title">Mind Tech</h5>
                                                <p>Las Vegas</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="pills-architect"
                                role="tabpanel"
                                aria-labelledby="pills-architect-tab"
                                
                            >
                                <div className="row">
                                    <div className="col-lg-4 col-md-6">
                                        <div className="portfolio-block">
                                            <div className="portfolio-img">
                                                <img
                                                    src={prot03}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                                <div className="overlay-bg" />
                                            </div>
                                            <div className="portfolio-dtl">
                                                <h5 className="portfolio-title">Mind Tech</h5>
                                                <p>Las Vegas</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-lg-4 col-md-6">
                                        <div className="portfolio-block">
                                            <div className="portfolio-img">
                                                <img
                                                    src={prot04}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                                <div className="overlay-bg" />
                                            </div>
                                            <div className="portfolio-dtl">
                                                <h5 className="portfolio-title">Mind Tech</h5>
                                                <p>Las Vegas</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="pills-large"
                                role="tabpanel"
                                aria-labelledby="pills-large-tab"
                                
                            >
                                <div className="row">
                                    <div className="col-lg-8">
                                        <div className="portfolio-block">
                                            <div className="portfolio-img">
                                                <img
                                                    src={prot01}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                                <div className="overlay-bg" />
                                            </div>
                                            <div className="portfolio-dtl">
                                                <h5 className="portfolio-title">Mind Tech</h5>
                                                <p>Las Vegas</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="pills-interiour"
                                role="tabpanel"
                                aria-labelledby="pills-interiour-tab"
                                
                            >
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="portfolio-block">
                                            <div className="portfolio-img">
                                                <img
                                                    src={prot02}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                                <div className="overlay-bg" />
                                            </div>
                                            <div className="portfolio-dtl">
                                                <h5 className="portfolio-title">Mind Tech</h5>
                                                <p>Las Vegas</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                className="tab-pane fade"
                                id="pills-house"
                                role="tabpanel"
                                aria-labelledby="pills-house-tab"
                                
                            >
                                <div className="row">
                                    <div className="col-lg-4">
                                        <div className="portfolio-block">
                                            <div className="portfolio-img">
                                                <img
                                                    src={prot05}
                                                    className="img-fluid"
                                                    alt=""
                                                />
                                                <div className="overlay-bg" />
                                            </div>
                                            <div className="portfolio-dtl">
                                                <h5 className="portfolio-title">Mind Tech</h5>
                                                <p>Las Vegas</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

        </>
    )
}

export default Portfolio
